export * from "./QrCodeLottery.builder";
